import Button from '../../../../../../components/buttons/Button';
import React from 'react';
import { deleteLabel } from '../../../../../../../common/labels/labelActions';
import { useDispatch } from 'react-redux';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { getLabelUsageData } from '../../../../../../element/labels/labelsService';

type Props = {
    label: Label;
    translate: (key: string, options?: Record<string, any>) => string;
};

const LabelDeleteButton = (props: Props) => {
    const { label, translate } = props;

    const dispatch = useDispatch();

    const deleteLabelHandler = async () => {
        const labeledElements = await getLabelUsageData(label._id);

        if (labeledElements.length === 0) {
            dispatch(deleteLabel(label._id));
            return;
        }

        if (confirm()) {
            dispatch(deleteLabel(label._id));
        }
    };

    return (
        <Button
            className="flex w-48 !mx-6 !py-1 !px-4 hover:!bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={deleteLabelHandler}
        >
            <div className="flex w-full items-center justify-between gap-4">
                <span>{translate('delete')}</span>
            </div>
        </Button>
    );
};

export default LabelDeleteButton;
